export const APP_CONSTANTS = {
  storageKeys: {
    customerAccessToken: 'blb_customer_access_token',
    customerExpiresAt: 'blb_customer_expires_at',
    cartId: 'blb_cart_id',
    wishlist: 'blb_wishlist',
  },
  pagination: {
    defaultPageSize: 12,
    maxPageSize: 50,
  },
  routes: {
    home: '/',
    shop: '/shop',
    collections: '/collections',
    cart: '/cart',
    wishlist: '/wishlist',
    checkout: '/checkout',
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    account: '/account',
    profile: '/account/profile',
    accountWishlist: '/account/wishlist',
    orders: '/account/orders',
    orderDetail: '/account/orders',
    addresses: '/account/addresses',
    blog: '/blog',
    contact: '/contact',
    about: '/about',
    soundHealing: '/sound-healing',
    /** Legacy path — redirects to /sound-healing */
    healingSessions: '/healing-sessions',
  },
} as const;
